'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaterialPricingController = function () {
  function MaterialPricingController(ProductsDataProvider, $stateParams) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MaterialPricingController);
    var product = $stateParams.product,
        material = $stateParams.material;


    this.tpl = product + '-' + material + '.html';
    this.ProductsDataProvider = ProductsDataProvider;
    this.product = ProductsDataProvider.products.findOne({ slug: $stateParams.product });
    this.material = this.product.materials.find(function (material) {
      return material.slug == $stateParams.material;
    });
    this.pricing = this.material.pricing;
  }

  (0, _createClass3.default)(MaterialPricingController, [{
    key: 'uniqueColors',
    value: function uniqueColors(colors) {
      var flags = {},
          flags2 = {};
      return colors.filter(function (color) {
        if (flags[color.hex1] && flags[color.hex2]) {
          return false;
        }
        flags[color.hex1] = true;
        flags2[color.hex2] = true;
        return true;
      });
    }
  }, {
    key: 'addColor',
    value: function addColor() {
      var _this = this;

      if (this.selected == undefined) return;
      if (this.material.slug == 'decor-1-color') {
        var alreadyHasColor = this.pricing.color.some(function (color) {
          return color.value.hex1 == _this.selected.hex1 && color.value.hex2 == _this.selected.hex2;
        });
        if (alreadyHasColor) {
          return;
        }
        this.pricing.color.push({
          calcMethod: 0,
          cost: 0,
          startCost: 0,
          value: { hex1: this.selected.hex1, hex2: this.selected.hex2 }
        });
      } else {
        var _alreadyHasColor = this.pricing.color.some(function (color) {
          return color.value == _this.selected.hex1;
        });
        if (_alreadyHasColor) {
          return;
        }
        this.pricing.color.push({ calcMethod: 0, cost: 0, startCost: 0, value: this.selected.hex1 });
      }
    }
  }, {
    key: 'removeColor',
    value: function removeColor(color, color1) {
      if (color1 != '') {
        var index = this.pricing.color.findIndex(function (el) {
          return el.value.hex1 === color && el.value.hex2 === color1;
        });
        if (index !== -1) {
          this.pricing.color.splice(index, 1);
        }
      } else {
        var _index = this.pricing.color.findIndex(function (el) {
          return el.value === color;
        });
        if (_index !== -1) {
          this.pricing.color.splice(_index, 1);
        }
      }
    }
  }, {
    key: 'newSizeCost',
    value: function newSizeCost() {
      var tableStand = {
        width: {
          min: 0,
          max: 0
        },
        height: {
          min: 0,
          max: 0
        },
        startCost: 0,
        cost: 0,
        weight: 20,
        calcMethod: 5
      };
      this.pricing.fixMethod['table-stand'].push(tableStand);
    }
  }, {
    key: 'newSizeCostCal',
    value: function newSizeCostCal() {
      var sizes = {
        width: {
          min: 0,
          max: 0
        },
        height: {
          min: 0,
          max: 0
        },
        startCost: 0,
        cost: 0,
        weight: 20,
        calcMethod: 5
      };
      if (this.pricing.fixMethod['sizes'] == undefined) this.pricing.fixMethod['sizes'] = [];
      this.pricing.fixMethod['sizes'].push(sizes);
    }
  }, {
    key: 'saveSpec',
    value: function saveSpec() {
      var productSlug = this.product.slug,
          materialSlug = this.material.slug;

      this.ProductsDataProvider.saveProductMaterialPricing(productSlug, materialSlug, this.pricing);
    }
  }]);
  return MaterialPricingController;
}();

// WEBPACK FOOTER //


exports.default = MaterialPricingController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/controller.js
 **/